module.exports = __webpack_public_path__ + "img/notification.6644ab1f.svg";